module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_8017.5aa7022b.png";